export type Graph = Record<
  number,
  { id: number; distance: number; type: string }[]
>;

export const buildGraph = (data: any): Graph => {
  const graph: Graph = {};

  data.forEach((space: any) => {
    space.pano.forEach((panorama: any) => {
      const nodeId = panorama.id;
      graph[nodeId] = panorama.connectedNode || [];
    });
  });
  return graph;
};

export const dijkstra = (
  graph: Graph,
  panoramaData: any[],
  startId: number,
  endId: number,
  selectedPath: string
) => {
  try {
    if (!graph[startId] || !graph[endId]) {
      throw new Error('Invalid start or end ID');
    }

    const distances: Record<number, number> = {};
    const previous: Record<number, number | null> = {};
    const queue: { id: number; cost: number }[] = [];

    // 모든 노드의 거리를 무한대로 초기화하고, 시작 노드는 0으로 설정
    Object.keys(graph).forEach((id) => {
      distances[Number(id)] = Infinity;
      previous[Number(id)] = null;
    });
    distances[startId] = 0;
    queue.push({ id: startId, cost: 0 });

    while (queue.length > 0) {
      // 우선순위 큐 정렬 (최소 거리 기준)
      queue.sort((a, b) => a.cost - b.cost);
      const { id: currentId, cost: currentCost } = queue.shift()!;

      if (currentId === endId) break; // 도착 노드에 도달하면 종료

      graph[currentId]
        ?.filter((item) => {
          if (selectedPath === 'Elevator')
            return item.type !== 'external_escalator';
          if (selectedPath === 'Escalator')
            return item.type !== 'external_elevator';
          return true; // "short" 또는 기본적으로 모든 경로 허용
        })
        .forEach(({ id: neighborId, distance }) => {
          const newCost = currentCost + distance;
          if (newCost < distances[neighborId]) {
            distances[neighborId] = newCost;
            previous[neighborId] = currentId;
            queue.push({ id: neighborId, cost: newCost });
          }
        });
    }

    // 도착 노드에 도달할 수 없는 경우
    if (distances[endId] === Infinity) {
      console.log('🚫 도달할 수 없는 노드:', endId);
      return {
        distance: Infinity,
        path: [],
        panorama_path: [],
        reachable: false,
      };
    }

    // 최단 경로 복원
    const path: number[] = [];
    const panorama_path: any[] = [];
    let current: number | null = endId;
    while (current !== null) {
      path.unshift(current);
      panoramaData.forEach((space) => {
        const panorama = space.pano.find((item: any) => item.id === current);
        if (panorama) panorama_path.unshift(panorama);
      });
      current = previous[current]!;
    }

    return {
      distance: distances[endId],
      path,
      panorama_path,
      reachable: true,
    };
  } catch (err) {
    console.log(err);
    return {
      distance: Infinity,
      path: [],
      panorama_path: [],
      reachable: false,
    };
  }
};
